import { useContext } from "react";

// Contexts
import { NotificationContext } from "@/contexts/NotificationContextProvider";

export const useNotifications = () => useContext(NotificationContext);
